// The API gateway only accepts text matching ^[\x09\x0A\x0D\x20-\x7E\xA0-\xFF]*$
// so characters such as "—", "₂" or "’" make the whole request fail validation.
const DISALLOWED = /[^\x09\x0A\x0D\x20-\x7E\xA0-\xFF]/;
const DISALLOWED_ALL = new RegExp(DISALLOWED.source, "g");

const ASCII_PUNCTUATION = {
  "–": "-",
  "—": "-",
  "‘": "'",
  "’": "'",
  "“": '"',
  "”": '"',
  "…": "...",
};

const toJsonEscape = (char) =>
  `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`;

// JSON text (e.g. a serialized snapshot): escape as \uXXXX, which is lossless
// because JSON.parse restores the original characters. Plain text: swap common
// typographic punctuation for its ASCII equivalent.
export const toGatewaySafeString = (value) => {
  if (typeof value !== "string" || !DISALLOWED.test(value)) return value;
  try {
    const parsed = JSON.parse(value);
    if (parsed !== null && typeof parsed === "object") {
      return value.replace(DISALLOWED_ALL, toJsonEscape);
    }
  } catch {
    // not JSON
  }
  return value.replace(DISALLOWED_ALL, (char) => ASCII_PUNCTUATION[char] ?? char);
};

export const toGatewaySafeBody = (body) => {
  if (typeof body === "string") return toGatewaySafeString(body);
  if (Array.isArray(body)) return body.map(toGatewaySafeBody);
  if (body !== null && typeof body === "object") {
    return Object.fromEntries(
      Object.entries(body).map(([key, value]) => [key, toGatewaySafeBody(value)]),
    );
  }
  return body;
};
